import Vuex from 'vuex'
import Vue from 'vue'
import sessionStore from '@/stores/session-store.js'

const abilities = {
  all: [
    '/lockers',
    '/delivery',
    '/profile',
    '/profile/name',
    '/profile/phone',
    '/profile/phone/verification',
    '/profile/delivery-code',
    '/profile/my-collectomates',
  ],

  user: [],

  admin: [
    // '/profile/collectomates'
  ],
}
Vue.use(Vuex)

const AuthorizationStore = new Vuex.Store({
  state: {
    // currentAnimation: 'slide-left',
    // tabLastPages: {}
  },
  getters: {
    can: () => path => {
      if (path.endsWith('/')) {
        path = path.substr(0, path.length - 1)
      }

      if (abilities.all.indexOf(path) != -1) {
        return true
      }

      const user = sessionStore.getters.user
      if (!!user && !!user.roles && user.roles.length) {
        let found = false
        _.each(user.roles, r => {
          if (abilities[r].indexOf(path) != -1) {
            found = true
            return false
          }
        })
        return found
      } else {
        return false
      }
    },
  },
})

export default AuthorizationStore
